module.exports = __webpack_public_path__ + "static/media/alps_active.9eb78e0c.png";